import React from 'react'
// import Modal from '@mui/material/Modal'
import ItemContainer from '../../item-container/ItemContainer'
import styled from '@emotion/styled'

const StyledDiv = styled.div`
  width: 80px;
`

const CoinModal = () => {
  return (
    <StyledDiv>
      <ItemContainer />
    </StyledDiv>
  )
}

export default CoinModal
